import { render, staticRenderFns } from "./VersionSettings.vue?vue&type=template&id=629b27fc"
import script from "./VersionSettings.vue?vue&type=script&lang=js"
export * from "./VersionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports